import React, { useState, useEffect, useRef } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // Main style file
import "react-date-range/dist/theme/default.css"; // Theme file
import { enGB } from "date-fns/locale"; // Only import the required locale
import moment from "moment";

const DateRangeInput = ({
  dateRange = null,
  showPicker = false,
  setShowPicker = () => {},
  handleSelect = () => {},
}) => {
  const pickerRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="position-relative z-10">
      <input
        type="text"
        value={`${
          dateRange?.startDate || moment(Date.now()).format("YYYY-MM-DD")
        } - ${dateRange?.endDate || moment(Date.now()).format("YYYY-MM-DD")}`}
        readOnly
        onClick={() => setShowPicker((prev) => !prev)}
        className="form-control border p-2 w-72 cursor-pointer"
      />

      {/* Date Range Picker */}
      {showPicker && (
        <div className="position-absolute mt-2" style={{ right: 0, zIndex: 9 }}>
          <DateRangePicker
            ranges={[
              {
                startDate: dateRange?.startDate
                  ? new Date(dateRange?.startDate)
                  : new Date(),
                endDate: dateRange?.endDate
                  ? new Date(dateRange?.endDate)
                  : new Date(),
                key: "selection",
              },
            ]}
            onChange={handleSelect}
            locale={enGB}
            disabledDates={[]}
            maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
            moveRangeOnFirstSelection={false}
          />
        </div>
      )}
    </div>
  );
};

export default DateRangeInput;
